import styled from 'styled-components'

export const HoursContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`
